"use client";

import blogs from "../data/blogs.json";
import Image from "next/image";
import Link from "next/link";
import { motion } from "framer-motion";
import Navbar from "../../components/navbar";



export default function BlogsPage() {

  
  const rest = blogs.slice(0);

  return (

    <section className="relative overflow-hidden bg-gradient-to-b from-white via-emerald-50/30 to-white py-24">
        <Navbar />

      {/* Ambient blobs */}
      <div className="absolute -left-40 top-20 size-[420px] rounded-full bg-emerald-200/40 blur-3xl"/>
      <div className="absolute right-0 bottom-0 size-[380px] rounded-full bg-cyan-200/40 blur-3xl"/>

      <div className="relative mx-auto max-w-7xl px-6 lg:px-12 py-10">

        {/* HERO */}
        <div className="text-center mb-10 ">
          <h1 className="text-5xl font-black text-gray-900 lg:text-6xl">
            Dental Health{" "}
            <span className="bg-gradient-to-r from-emerald-600 to-emerald-400 bg-clip-text text-transparent">
              Insights
            </span>
          </h1>

          <p className="mt-4 text-lg text-gray-600 max-w-2xl mx-auto ">
            Expert advice, treatment guides, and oral care tips from
            Pinak Dental Clinic specialists.
          </p>
        </div>


        {/* BLOG GRID */}
        <div className="grid gap-10 md:grid-cols-2 lg:grid-cols-3">

          {rest.map((blog, i) => (
            <Link key={blog.slug} href={`/blogs/${blog.slug}`}>

              <motion.div
                initial={{ opacity:0, y:40 }}
                animate={{ opacity:1, y:0 }}
                transition={{ delay: i * 0.05 }}
                whileHover={{ y:-8 }}
                className="group overflow-hidden rounded-3xl bg-white shadow-lg hover:shadow-2xl transition"
              >

                {/* IMAGE */}
                <div className="relative h-[220px] w-full overflow-hidden">
                  <Image
                    src={blog.coverImage}
                    alt={blog.title}
                    fill
                    className="object-cover group-hover:scale-110 transition duration-500"
                  />
                </div>

                {/* CONTENT */}
                <div className="p-6">

                  <span className="text-xs font-semibold text-emerald-600">
                    {blog.category}
                  </span>

                  <h3 className="mt-2 text-xl font-bold text-gray-900 group-hover:text-emerald-600 transition">
                    {blog.title}
                  </h3>

                  <p className="mt-3 text-sm text-gray-600 line-clamp-3">
                    {blog.excerpt}
                  </p>

                  <div className="mt-4 text-xs text-gray-500">
                    {blog.date} • {blog.readTime}
                  </div>

                </div>

              </motion.div>

            </Link>
          ))}

        </div>

      </div>
    </section>
  );
}